const translateSeparator = "_._";
const getTranslates = () => typeof window !== "undefined" ? window.translates : {};
const selectTranslatableData = (translates, section, category, name) => {
  try {
    const translatableSection = translates[section] || translates[section.toLowerCase()];
    const translatableCategory = translatableSection[category] || translatableSection[category.toLowerCase()];
    const translatableName = translatableCategory[name] || translatableCategory[name.toLowerCase()];
    return translatableName === null ? "" : translatableName || name;
  } catch (e) {
    return name;
  }
};
const getTranslateString = (string) => {
  const modifiedNameArr = `${string || ""}`.split(translateSeparator);
  if (modifiedNameArr && modifiedNameArr.length === 1) {
    return {
      translate: string,
      skipTranslate: true
    };
  }
  const translate = selectTranslatableData(
    getTranslates(),
    modifiedNameArr[0] || "",
    modifiedNameArr[1] || "",
    modifiedNameArr[2] || ""
  );
  return {
    translate,
    modifiedName: modifiedNameArr[2]
  };
};
const __ = (name, ...args) => {
  const { translate, skipTranslate, modifiedName } = getTranslateString(name);
  let trString = translate;
  if (skipTranslate) {
    return name;
  }
  try {
    if (args == null ? void 0 : args.length) {
      const argObject = args[0] || {};
      Object.entries(argObject).forEach(([rawKey, value]) => {
        const cleanKey = rawKey.replace(/{{|}}/g, "");
        const { translate: argTranslate, modifiedName: argModifiedName } = getTranslateString(String(value));
        const replacement = argTranslate || argModifiedName;
        trString = trString.replaceAll(`%${cleanKey}%`, replacement).replaceAll(`{{${cleanKey}}}`, replacement);
      });
    }
    return typeof trString === "string" ? trString : "";
  } catch (e) {
    return modifiedName || name;
  }
};
export {
  __,
  getTranslateString,
  selectTranslatableData
};
